import React from "react";
import { industries } from "../mock";
import { Dot } from "lucide-react";

export default function IndustriesWeDealIn() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">We Serve</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">We Deal In</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {industries.map(i => (
            <div key={i} className="flex items-center gap-1 bg-cream border border-orange-100 text-neutral-800 hover:bg-orange-500 hover:text-white hover:border-orange-500 transition-colors px-5 py-2.5 rounded-full text-sm font-semibold cursor-default">
              <Dot size={20} className="text-orange-500" />
              {i}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
